import { type VersionedSpec } from '@/designs-dev/handover/versions';
import { benefitsCalculator10Spec } from '@/karehero-app/handover/benefits-calculator-1-0';

// The benefits calculator, every version on one page. See versions.ts.
//
// The 5 October proposal (paperwork first, round 3 notes) was a concept, so it
// sits under the group's Concepts rather than in this history.

export const benefitsCalculatorVersions: VersionedSpec = {
  id: 'benefits-calculator',
  title: 'Benefits calculator',
  versions: [
    {
      n: '1.0',
      draft: true,
      note: "The first config in the shared chat engine: main's questions, in onboarding 4's chat.",
      spec: benefitsCalculator10Spec,
      changes: [
        'Skips what onboarding already holds, said back in the first message to check. Three things or fewer are said; more go in a list.',
        'Main\'s question set and "only if" rules, word for word.',
        'One question a turn. Options only for savings, income and benefit names; everything else in their own words.',
        'Benefits they already get is multi-select: tick each one, then Done.',
        'Ends in Profile, under Assess, where the results stay to come back to. No amounts, and a way on if nothing comes back.',
      ],
    },
  ],
};
